import styled from "styled-components";
import breakpoints from "../../../styles/breakpoints";
import theme from "../../../styles/theme";

const SubTopbar = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 8rem auto 0 auto;
  width: 100%;
  padding: 0 2rem;
  @media (${breakpoints.min800}) {
    margin: ${({ withSidebar, isOpen }: { withSidebar: boolean; isOpen: boolean }) =>
      withSidebar && isOpen
        ? `8rem auto 0 ${theme.sidebarWidth}`
        : withSidebar
        ? `8rem auto 0 ${theme.collapsedWidth}`
        : "8rem auto 0 auto"};
    max-width: ${theme.maxWidth};
    transition: margin 500ms;
  }
`;

export default SubTopbar;
